import React, { FC, memo } from "react";
import { Icon } from "@material-ui/core";
import styles from "./Key.module.scss";
import { ReactComponent as ShiftIcon } from "../../../assets/icons/shift.svg";
import { ReactComponent as Backspace } from "../../../assets/icons/backspace.svg";
import {
  OrientationType,
  ResolutionType,
  useScreenStore,
} from "application/contexts/screen/ScreenStore";

interface KeyProps {
  onClick: (key: string) => void;
  children: string;
  type: "number" | "letter" | "password";
  disable?: boolean;
}

export const Key: FC<KeyProps> = memo((props) => {
  const { resolution, orientation } = useScreenStore();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    props.onClick(props.children);
  };

  return (
    <button
      onClick={handleClick}
      disabled={props.disable}
      className={styles.keyContainer}
      style={{
        visibility: props.children ? "visible" : "hidden",
        backgroundColor:
          props.children === "check"
            ? "#2DA04C"
            : props.children === "back-space" && props.type === "number"
            ? "#e0e0e0"
            : props.children === "clear"
            ? "#e0e0e0"
            : "#fff",
        width: "100%",
        height:
          props.type === "number" || props.type === "password"
            ? resolution === ResolutionType.FULL_HD
              ? orientation === OrientationType.PORTRAIT
                ? 150
                : 100
              : 70
            : 75,
        boxShadow:
          props.type === "number" || props.type === "password"
            ? "0px 4px 12px 0px rgba(0, 0, 0, 0.10)"
            : "0px 1.451px 0px 0px rgba(0, 0, 0, 0.30)",
        fontSize: props.children.length > 1 ? 22 : 30,
        color:
          props.children === "check" || props.children === "back-space"
            ? "#fff"
            : "unset",
      }}
    >
      {props.children === "back-space" ? (
        <>
          {props.type === "letter" ? (
            <Backspace />
          ) : (
            <Icon style={{ color: "#333333" }} fontSize="large">
              backspace
            </Icon>
          )}
        </>
      ) : props.children === "clear" ? (
        <>
          <div>LIMPAR</div>
        </>
      ) : props.children === "check" ? (
        <>
          <Icon fontSize={"large"}>check</Icon>
        </>
      ) : props.children === "shift" ? (
        <ShiftIcon />
      ) : props.children === " " ? (
        <Icon>space_bar</Icon>
      ) : (
        props.children
      )}
    </button>
  );
});
